'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var common = require('arm-common');
var p = require('prop-types');
var agui = require('arm-gui');
var armRouter = require('arm-router');
var update = require('immutability-helper');
var controls = require('arm-gui/dist/controls');
var events = require('events');
var reactTransitionGroup = require('react-transition-group');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var common__default = /*#__PURE__*/_interopDefaultLegacy(common);
var p__namespace = /*#__PURE__*/_interopNamespace(p);
var p__default = /*#__PURE__*/_interopDefaultLegacy(p);
var agui__default = /*#__PURE__*/_interopDefaultLegacy(agui);
var agui__namespace = /*#__PURE__*/_interopNamespace(agui);
var update__default = /*#__PURE__*/_interopDefaultLegacy(update);

var classNamePrefix$m = 'arm-core-layouts-user-info';
/**
 * @example
 * ```jsx
 * const menuItems = [
 *      {
 *          label: utente.firstname,
 *          className: 'hoverless' //hoverless: unclickable
 *      },
 *      {
 *          label: i18n('USER_INFO.SETTINGS', 'Impostazioni'),
 *          link: '#/settings',
 *          icon: 'fas fa-cog',
 *          className: 'no-separator' //no-separator: to remove the line that separe the items
 *      },
 *      {
 *          label: i18n('USER_INFO.LOG_OUT', 'Disconnettiti'),
 *          onClick: () => logoutOnClick && logoutOnClick().then(() => history.replace('logout'))
 *      }      
 * ];
 * <UserInfo 
 *      menuItems={menuItems}
 *      userName={utente.firstname}
 * />
 * ```
 */

function UserInfo(_ref) {
  var menuItems = _ref.menuItems,
      userName = _ref.userName;
  console.log('[UserInfo.jsx]: render');
  return /*#__PURE__*/React__namespace.createElement(agui.PopupMenu, {
    popupIcon: null,
    className: classNamePrefix$m,
    label: userName == null ? void 0 : userName.charAt(0).toUpperCase(),
    items: menuItems
  });
}
UserInfo.propTypes = {
  userName: p__namespace.string,
  menuItems: p__namespace.array
};

/**
 * @typedef {object} TopBarProps TopBar properties
 * @prop {string} [homePath] Alternative path of default: 'home'
 * @prop {string} [logo] path/to/logo
 * @prop {string} [userName]
 * @prop {PopupMenuItemProp[]} [userMenu] user menu items
 * @prop {React.Node} [children] MenuLink or MenuDrop components
 */

/**
 * @callback _TopBar Navigation bar of the application
 * @param {TopBarProps} props
 * @returns {JSX.Element} TopBar component
 */

exports.typedefs = {};

var NavBarElemRight = function NavBarElemRight(props) {
  console.log("[NavBarElemRight.jsx]: render");
  var id = props.id,
      className = props.className,
      children = props.children;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: id,
    className: className ? "arm-nav-bar-right " + className : "arm-nav-bar-right"
  }, children);
};

var NavBarElem = function NavBarElem(props) {
  console.log("[NavBarElem.jsx]: render");
  var id = props.id,
      className = props.className,
      children = props.children;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: id,
    className: className ? "arm-nav-bar-elem " + className : "arm-nav-bar-elem"
  }, children);
};

var NavBar = function NavBar(props) {
  console.log("[NavBar.jsx]: render");
  var id = props.id,
      className = props.className,
      children = props.children;
  return /*#__PURE__*/React__default["default"].createElement("nav", {
    id: id,
    className: className ? "arm-nav-bar " + className : "arm-nav-bar"
  }, children);
};
/**
 * Navigation bar of the application
 * 
 * @example
 * ```jsx
 * const userMenu = [
 *      {
 *          label: utente.firstname,
 *          className: 'hoverless' //hoverless: unclickable
 *      },
 *      {
 *          label: i18n('USER_INFO.SETTINGS', 'Impostazioni'),
 *          link: '#/settings',
 *          icon: 'fas fa-cog',
 *          className: 'no-separator' //no-separator: to remove the line that separe the items
 *      },
 *      {
 *          label: i18n('USER_INFO.LOG_OUT', 'Disconnettiti'),
 *          onClick: () => logoutOnClick && logoutOnClick().then(() => history.replace('logout'))
 *      }      
 * ];
 * <TopBar homePath="home" logo="./images/fideuram_logo.png" userMenu={userMenu} userName={utente.firstname}>
 *      <MenuLink to="/brand"> Brand </MenuLink>
 *      <MenuLink to="/contacts"> Contacts </MenuLink>
 * </TopBar>
 * ```
 * @type {_TopBar}
 */


function TopBar(_ref) {
  var homePath = _ref.homePath,
      logo = _ref.logo,
      userMenu = _ref.userMenu,
      userName = _ref.userName,
      children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement(NavBar, {
    className: "arm-core-layouts-top-bar"
  }, /*#__PURE__*/React__default["default"].createElement(NavBarElem, {
    className: "logo"
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    href: "#/" + (homePath || 'home')
  }, logo && /*#__PURE__*/React__default["default"].createElement("img", {
    src: logo
  }))), /*#__PURE__*/React__default["default"].createElement(NavBarElem, null, /*#__PURE__*/React__default["default"].createElement(armRouter.Menu, null, children)), /*#__PURE__*/React__default["default"].createElement(NavBarElemRight, null, /*#__PURE__*/React__default["default"].createElement(UserInfo, {
    menuItems: userMenu,
    userName: userName
  })));
}
var childrenType = p__default["default"].shape({
  type: p__default["default"].oneOf([armRouter.MenuLink, armRouter.MenuDrop])
});
TopBar.propTypes = {
  homePath: p__default["default"].string,
  logo: p__default["default"].string,
  userMenu: agui.PopupMenu.propTypes.items,
  userName: p__default["default"].string,
  children: p__default["default"].oneOfType([childrenType, p__default["default"].arrayOf(childrenType)])
};

var classNamePrefix$l = 'arm-core-layouts-application-container';
function ApplicationContainer(props) {
  console.log('[ApplicationContainer]: render');
  var _props$id = props.id,
      id = _props$id === void 0 ? common.Utils.uuid(classNamePrefix$l) : _props$id,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      children = props.children;

  var _useState = React.useState((classNamePrefix$l + " " + className).trimEnd()),
      classNameComp = _useState[0],
      setClassNameComp = _useState[1];

  React.useEffect(function () {
    var baseClassName = (classNamePrefix$l + " " + className).trimEnd();

    if (React__default["default"].Children.toArray(children).find(function (child) {
      return child && child.type.toString() === TopBar.toString();
    })) {
      setClassNameComp(baseClassName + " " + classNamePrefix$l + "-with-topbar");
    } else {
      setClassNameComp(baseClassName);
    }
  }, [children]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: id,
    className: classNameComp
  }, children);
}
ApplicationContainer.propTypes = {
  id: p__namespace.string,
  className: p__namespace.string,
  children: p__namespace.node
};

function Body(props) {
  console.log('[ApplicationContainer.Body]: render');
  var _props$id2 = props.id,
      id = _props$id2 === void 0 ? common.Utils.uuid(classNamePrefix$l + "-body") : _props$id2,
      _props$className2 = props.className,
      className = _props$className2 === void 0 ? '' : _props$className2,
      children = props.children;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: id,
    className: (classNamePrefix$l + "-body " + className).trimEnd()
  }, children);
}
Body.propTypes = {
  children: p__namespace.node,
  id: p__namespace.string,
  className: p__namespace.string
};
ApplicationContainer.Body = Body;

var errChildren = function errChildren() {
  console.warn("[CollapseContent.jsx]: the children of component must be two.");
  return /*#__PURE__*/React__namespace.createElement("div", null, " add two children to component ", /*#__PURE__*/React__namespace.createElement("pre", null, "CollapseContent"), " ");
}; //TODO: aggiungere funzionalità pinnable (come in outlook)


var CollapseContent = function CollapseContent(props) {
  console.log("[CollapseContent.jsx]: render");
  props.id;
      props.width;
      var nextElemWidth = props.nextElemWidth,
      children = props.children;
  if (children && React__namespace.Children.count(children) !== 2) errChildren();

  var _React$useState = React__namespace.useState(false),
      collapse = _React$useState[0];
      _React$useState[1];

  var styleMenu = {
    height: nextElemWidth || "calc( 100vh - " + "70px" + ")"
  };
  var styleContentItems = {
    width: "calc( 100% - " + "107px" + ")"
  };

  if (collapse) {
    styleContentItems = {
      width: '100%'
    };
  }

  return /*#__PURE__*/React__namespace.createElement("div", {
    className: "arm-core-layouts-collapse-content-container"
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: "arm-core-layouts-collapse-content-menu",
    style: styleMenu
  }, children[0]), /*#__PURE__*/React__namespace.createElement("div", {
    className: "arm-core-layouts-collapse-content-items",
    style: styleContentItems
  }, children[1]));
};

CollapseContent.propTypes = {
  id: p__namespace.string,
  width: p__namespace.string.isRequired,
  nextElemWidth: p__namespace.string,
  children: p__namespace.node
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var classNamePrefix$k = 'arm-core-layouts-reduce-icon';
var reduceIcon = 'fas fa-angle';

function ReduceIcon(props) {
  console.log('[ReduceIcon]: render');
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$position = props.position,
      position = _props$position === void 0 ? 'left' : _props$position,
      id = props.id,
      onClick = props.onClick;
  return /*#__PURE__*/React__default["default"].createElement("i", {
    id: id,
    className: classNamePrefix$k + " " + reduceIcon + "-" + position + " " + className,
    title: common.i18n('ARM_CORE_LAYOUTS.REDUCE', 'Reduce'),
    onClick: onClick
  });
}

ReduceIcon.propTypes = {
  id: p__namespace.string,
  className: p__namespace.string,
  position: p__namespace.oneOf(['left', 'right']),
  onClick: p__namespace.func
};

/**
 * @typedef {object} MenuLeftProps MenuLeft properties
 * @param {string} [className] div selector
 * @param {string|number} [widthOpen='9rem'] determines the visibility of the element
 * @param {string|number} [widthClose='4rem'] icon selector
 * @param {Array<(MenuLeftItem|Node)>} children
 */

/**
 * @callback _MenuLeft side menu bar that stands on left
 * @param {MenuLeftProps} props 
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} MenuLeftItemProps MenuLeftItem properties
 * @prop {string} [className] div selector
 * @prop {boolean} [visible=true] determines the visibility of the element
 * @prop {string} [icon] icon selector
 * @prop {string} [title] MenuLeftItem label
 * @prop {Node} [children] MenuLeftItem label
 */

/**
 * @callback _MenuLeftItem Item of MenuLeft
 * @param {(MenuLeftItemProps|import('arm-router').MenuLinkProps)|import('arm-router').NavLinkProps)} props 
 * @returns {JSX.Element}
 */
exports.typedef = {};

var _excluded$2 = ["className", "visible", "icon", "title", "label", "children", "openMenu", "to"];
var classNamePrefix$j = 'arm-core-layouts-menu-left';
/** @type {_MenuLeft} */

function MenuLeft(props) {
  console.log('[MenuLeft]: render');
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      widthOpen = props.widthOpen,
      widthClose = props.widthClose,
      children = props.children;
  var initialState = {
    menu: {
      open: true,
      width: widthOpen || '9rem',
      widthOpen: widthOpen || '9rem',
      widthClose: widthClose || '5rem'
    },
    style: {
      width: widthOpen || '9rem',
      top: 0
    }
  };
  var ref = React.useRef();

  var _useState = React.useState(initialState),
      state = _useState[0],
      setstate = _useState[1];

  React.useEffect(function () {
    if (ref.current && hasTopBar()) {
      setstate(update__default["default"](state, {
        style: {
          top: {
            $set: "5rem"
          }
        }
      }));
    }
  }, [ref]);
  var idIconDiv = common.Utils.uuid(classNamePrefix$j + "-icon-container");

  var onclickIcon = function onclickIcon() {
    var menuOpen = !state.menu.open;
    var width = state.menu.widthOpen;
    if (!menuOpen) width = state.menu.widthClose;
    var newState = update__default["default"](state, {
      menu: {
        open: {
          $set: menuOpen
        },
        width: {
          $set: width
        }
      },
      style: {
        width: {
          $set: width
        }
      }
    });
    setstate(newState);
  };

  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: ref,
    className: (classNamePrefix$j + " " + className).trimEnd(),
    style: state.style,
    width: state.menu.width
  }, /*#__PURE__*/React__default["default"].createElement(armRouter.Menu, {
    className: classNamePrefix$j + "-body",
    height: "100%",
    vertical: true
  }, children && React__default["default"].Children.map(children, function (child) {
    if (child && child.type && child.type.toString() === MenuLeftItem.toString()) {
      return /*#__PURE__*/React__default["default"].cloneElement(child, _extends({}, child.props, {
        openMenu: state.menu.open
      }));
    } else {
      return child;
    }
  }), /*#__PURE__*/React__default["default"].createElement(ReduceIcon, {
    position: state.menu.open ? 'left' : 'right',
    id: idIconDiv,
    className: classNamePrefix$j + "-icon-container",
    onClick: onclickIcon
  })));
}
MenuLeft.propTypes = {
  className: p__namespace.string,
  widthOpen: p__namespace.string,
  widthClose: p__namespace.string,
  children: p__namespace.node.isRequired
};
/** @type {_MenuLeftItem} */

function MenuLeftItem(props) {
  console.log('[MenuLeftItem]: render');

  var _props$className2 = props.className,
      className = _props$className2 === void 0 ? '' : _props$className2,
      _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      icon = props.icon,
      title = props.title,
      label = props.label,
      children = props.children,
      openMenu = props.openMenu,
      _props$to = props.to,
      to = _props$to === void 0 ? '#' : _props$to,
      menuLinkProps = _objectWithoutPropertiesLoose(props, _excluded$2);

  if (!visible) return null;
  var menuLinkClassName = 'arm-core-layouts-menu-link';

  if (className) {
    menuLinkClass += className;
  }

  var iconCls = ' arm-core-layouts-menu-left-item-icon ';

  if (icon) {
    iconCls += icon;
  }

  return /*#__PURE__*/React__default["default"].createElement(armRouter.MenuLink, _extends({
    activeClassName: menuLinkClassName + "-selected",
    to: to.toString(),
    className: (menuLinkClassName + " " + className).trimEnd()
  }, menuLinkProps), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "arm-core-layouts-menu-left-item"
  }, /*#__PURE__*/React__default["default"].createElement("i", {
    className: iconCls
  }), openMenu && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "arm-core-layouts-menu-left-title"
  }, label || title || children)));
}
MenuLeftItem.propTypes = _extends({
  visible: p__namespace.bool,
  icon: p__namespace.string,
  title: p__namespace.string,
  className: p__namespace.string,
  children: p__namespace.node
}, armRouter.MenuLink.propTypes);
MenuLeft.Item = MenuLeftItem;

function hasTopBar() {
  return !!document.getElementsByClassName('arm-core-layouts-top-bar')[0];
}

var classNamePrefix$i = 'arm-core-layouts-page-container';
function PageContainer(props) {
  console.log('[PageContainer]: render');
  var _props$id = props.id,
      id = _props$id === void 0 ? common.Utils.uuid(classNamePrefix$i) : _props$id,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      children = props.children;
  var ref = React.useRef();

  var _useState = React.useState(style),
      styleComp = _useState[0],
      setStyleComp = _useState[1];

  var _useState2 = React.useState(null),
      pageHeaderHeight = _useState2[0],
      setPageHeaderHeight = _useState2[1];

  var _useState3 = React.useState(null),
      pageFooterHeight = _useState3[0],
      setPageFooterHeight = _useState3[1];

  var _useState4 = React.useState(new MutationObserver(function (mutations) {
    mutations.forEach(function (mutationRecord) {
      return setPageHeaderHeight(mutationRecord.target.style.height);
    });
  })),
      observer = _useState4[0];

  React.useEffect(function () {
    if (ref.current) {
      var pageHeaderContainerElem = ref.current.getElementsByClassName('arm-core-layouts-page-header-container')[0];

      if (pageHeaderContainerElem) {
        setPageHeaderHeight(pageHeaderContainerElem.style.height);
        observer.observe(pageHeaderContainerElem, {
          attributes: true,
          attributeFilter: ['style']
        });
      }

      var pageFooterContainerElem = ref.current.getElementsByClassName('arm-core-layouts-page-footer')[0];

      if (pageFooterContainerElem) {
        setPageFooterHeight(getComputedStyle(pageFooterContainerElem).height);
      }
    }
  }, [ref, children]);
  React.useEffect(function () {
    var newStyle = _extends({}, styleComp);

    if (pageHeaderHeight) newStyle.paddingTop = pageHeaderHeight;
    if (pageFooterHeight) newStyle.paddingBottom = pageFooterHeight;
    if (pageHeaderHeight || pageFooterHeight) setStyleComp(newStyle);
  }, [pageHeaderHeight, pageFooterHeight]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: ref,
    id: id,
    className: (classNamePrefix$i + " " + className).trimEnd(),
    style: styleComp
  }, children);
}
PageContainer.propTypes = {
  id: p__namespace.string,
  className: p__namespace.string,
  style: p__namespace.object,
  children: p__namespace.node
};

var classNamePrefix$h = 'arm-core-layouts-masterpagecontainer';
function MasterPageContainer(props) {
  console.log('[MasterPageContainer.jsx]: render');
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      children = props.children;
  var ref = React.useRef();

  var _useState = React.useState(style),
      styleComp = _useState[0],
      setStyleComp = _useState[1];

  var menuLeftWidth = getMenuLeftWidth(ref, children);
  React.useEffect(function () {
    if (menuLeftWidth || menuLeftWidth === 0) {
      setStyleComp(_extends({}, styleComp, {
        paddingLeft: menuLeftWidth
      }));
    }
  }, [menuLeftWidth]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: ref,
    className: (classNamePrefix$h + " " + className).trimEnd(),
    style: styleComp
  }, children);
}
MasterPageContainer.propTypes = {
  className: p__namespace.string,
  style: p__namespace.object,
  children: p__namespace.node
};
function getMenuLeftWidth() {
  var baseWidth = 0;
  var menuLeftElem = document.getElementsByClassName('arm-core-layouts-menu-left')[0];
  if (menuLeftElem) baseWidth = menuLeftElem.style.width;

  var _useState2 = React.useState(baseWidth),
      width = _useState2[0],
      setWidth = _useState2[1];

  var _useState3 = React.useState(new MutationObserver(function (mutations) {
    mutations.forEach(function (mutationRecord) {
      return setWidth(mutationRecord.target.style.width);
    });
  })),
      observer = _useState3[0];

  for (var _len = arguments.length, updatesEffects = new Array(_len), _key = 0; _key < _len; _key++) {
    updatesEffects[_key] = arguments[_key];
  }

  React.useEffect(function () {
    var menuLeftElem = document.getElementsByClassName('arm-core-layouts-menu-left')[0];

    if (menuLeftElem) {
      setWidth(menuLeftElem.style.width);
      observer.observe(menuLeftElem, {
        attributes: true,
        attributeFilter: ['style']
      });
    } else setWidth(0);
  }, updatesEffects);
  return width;
}

//#region PageFilter

/**
 * @typedef {object} PageFilterProps PageFilter properties
 * @prop {string} [className] div selector
 * @prop {import("react").JSXElementConstructor<_PageFilterGroup>|Array<import("react").JSXElementConstructor<_PageFilterGroup>>} children one or more PageFilterGroup
 */

/**
 * @callback _PageFilter element that goes on bottom of PageHeader, used with PageFilterGroup
 * @param {PageFilterProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} PageFilterGroupProps PageFilterGroup properties
 * @prop {string} [className] div selector
 * @prop {boolean} [right=false] justify the grouped elements on the right
 * @prop {('stretch'|'center'|'flex-start'|'flex-end'|'baseline'|'initial'|'inherit')} [alignItems='flex-end'] property to vertically align the elements grouped 
 * @prop {Node} [children] React.Children
 */

/**
 * @callback _PageFilterGroup component used as child of PageFilter, that render the elements passed side by side
 * @param {PageFilterGroupProps} props 
 * @returns {JSX.Element}
 */
//#endregion PageFilter
//#region PageFilterPanel

/**
 * @typedef {object} PageFilterPanelProps PageFilterPanel properties
 * @prop {Array<import("react").Component>} children PageFilterPanel children
 */

/**
 * @callback _PageFilterPanel
 * @param {PageFilterPanelProps} props
 * @returns {JSX.Element}
 */
//#region PageHeader

/**
 * @typedef {object} PageHeaderContainerProps PageHeaderContainer properties
 * @prop {_PageHeader|Array<(_PageHeader|_PageFilter|_PageFilterPanel)>} children required a PageHeader or couple PageHeader/PageFilter
 */

/**
 * @callback _PageHeaderContainer element that contains PageHeader or couple PageHeader/PageFilter
 * @param {PageHeaderContainerProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} UrlProp url object properties
 * @prop {string} url href destination
 * @prop {string} label label visualized
 * @prop {() => void} onClick use click event instead of href destination
 */

/**
 * @typedef {object} PageHeaderProps PageHeaderProps properties
 * @prop {string} className div selector
 * @prop {string} title title of header
 * @prop {Array<UrlProp>} breadcrumbs list of breadcrumbs representing the path routes
 * @prop {(string|UrlProp)} backurl href back destination
 * @prop {Node} children React.Children
 */

/**
 * @callback _PageHeader element child of PageHeaderContainer, that represent the heading of a page
 * @param {PageHeaderProps} props
 * @returns {JSX.Element}
 */
//#endregion PageHeader 
exports.typedef = {};

var classNamePrefix$g = 'arm-core-layouts-page-filter-panel';
/**
 * component used as child of PageHeaderContainer, that render an extensive panel only for filters
 * @type _PageFilterPanel
 */

var PageFilterPanel = function PageFilterPanel(props) {
  console.log('[PageFilterPanel]: render');
  var children = props.children;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "" + classNamePrefix$g
  }, children);
};

/**
 * @typedef {object} ElementBarProps ElementBar properties
 * 
 * @prop {string} [labelMore] label of more button
 * @prop {string} [iconMore] icon of more button
 * @prop {string} [classNameBar] div selector
 * @prop {boolean} [compact] pass the property `compact` to children
 * @prop {('left'|'right')} [barPosition='right'] justify the elements on right or left
 * @prop {('stretch'|'center'|'flex-start'|'flex-end'|'baseline'|'initial'|'inherit')} [alignItems] vertical align the elements
 * @prop {Node} children
 */

/**
 * @callback _ElementBar Component that render elements side by side according to the available size of the father container
 * @param {ElementBarProps} props
 * @returns {JSX.Element}
 */
exports.typedef = {};

var _excluded$1 = ["children"],
    _excluded2 = ["avoidMore"];
var idCounter$2 = 0;
var classNamePrefix$f = 'arm-core-layouts-element-bar';
/** @type {_ElementBar} */

function ElementBar(_ref) {
  var _props$iconMore;

  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var _useState = React.useState(null),
      fatherSelector = _useState[0],
      setFatherSelector = _useState[1];

  var _useState2 = React.useState(null),
      listInitialElements = _useState2[0],
      setListElWithWidth = _useState2[1];

  var _useState3 = React.useState(null),
      moreButtonWidth = _useState3[0],
      setMoreButtonWidth = _useState3[1];

  var listElRef = [];
  React__default["default"].Children.forEach(children, function (child) {
    listElRef.push({
      ref: React.useRef(),
      el: child
    });
  });
  var fakeChildRef = React.useRef();
  var containerRef = React.useRef();
  var moreBtnRef = React.useRef();
  React.useEffect(function () {
    if (fakeChildRef.current) {
      setFatherSelector(fakeChildRef.current.parentElement.className);
    }
  }, [fakeChildRef]);
  React.useEffect(function () {
    if (containerRef.current) {
      var elWithWidth = [];
      listElRef.forEach(function (elref) {
        var ref = elref.ref,
            el = elref.el;
        if (ref.current) elWithWidth.push({
          element: el,
          width: ref.current.previousElementSibling.offsetWidth
        });
      });
      setMoreButtonWidth(moreBtnRef.current.offsetWidth);
      setListElWithWidth(elWithWidth);
    }
  }, [fatherSelector, containerRef, children]);
  if (listInitialElements) return /*#__PURE__*/React__default["default"].createElement(RenderElementBar, _extends({
    listInitialElements: listInitialElements,
    moreButtonWidth: moreButtonWidth,
    children: children
  }, props));
  var styleGettingWidth = {
    display: 'flex',
    position: 'fixed',
    top: 5000000,
    width: '100vw'
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    ref: fakeChildRef
  }), /*#__PURE__*/React__default["default"].createElement(agui.ModalContainer, null, fatherSelector !== null && /*#__PURE__*/React__default["default"].createElement("div", {
    style: styleGettingWidth,
    ref: containerRef,
    className: (classNamePrefix$f + "-getting-width " + fatherSelector).trimEnd()
  }, listElRef.map(function (elref, index) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, {
      key: classNamePrefix$f + "-el-in-getting-width-" + index
    }, /*#__PURE__*/React__default["default"].createElement("div", null), " ", elref.el, /*#__PURE__*/React__default["default"].createElement("span", {
      ref: elref.ref,
      style: {
        display: 'inline-flex'
      }
    }));
  }), /*#__PURE__*/React__default["default"].createElement(agui__default["default"].aButton, {
    btnRef: moreBtnRef,
    icon: (_props$iconMore = props.iconMore) != null ? _props$iconMore : 'fas fa-ellipsis-v'
  }, !props.compact ? props.labelMore || common.i18n('ARM_CORE_LAYOUTS.ELEMENT_BAR.MORE', 'Altro') : null))));
}

function RenderElementBar(props) {
  var children = props.children,
      _props$iconMore2 = props.iconMore,
      iconMore = _props$iconMore2 === void 0 ? 'fas fa-ellipsis-v' : _props$iconMore2,
      _props$labelMore = props.labelMore,
      labelMore = _props$labelMore === void 0 ? common.i18n('ARM_CORE_LAYOUTS.ELEMENT_BAR.MORE', 'Altro') : _props$labelMore,
      _props$barPosition = props.barPosition,
      barPosition = _props$barPosition === void 0 ? 'right' : _props$barPosition,
      _props$classNameBar = props.classNameBar,
      classNameBar = _props$classNameBar === void 0 ? '' : _props$classNameBar,
      _props$compact = props.compact,
      compact = _props$compact === void 0 ? false : _props$compact,
      alignItems = props.alignItems,
      listInitialElements = props.listInitialElements,
      moreButtonWidth = props.moreButtonWidth;
  var barPos = classNamePrefix$f + "-" + barPosition;
  var elementBarRef = React.useRef(null);
  var containerRef = React.useRef(null);

  var _useState4 = React.useState(null),
      width = _useState4[0],
      setWidth = _useState4[1];

  var _useState5 = React.useState(null),
      resizeObserver = _useState5[0],
      setResizeObserver = _useState5[1];

  var _useState6 = React.useState(classNamePrefix$f + "-" + ++idCounter$2),
      idComp = _useState6[0];

  var _useState7 = React.useState(false),
      showContent = _useState7[0],
      setShowContent = _useState7[1];

  var _useState8 = React.useState([]),
      listMore = _useState8[0],
      setListMore = _useState8[1];

  var _useState9 = React.useState([]),
      listFixed = _useState9[0],
      setListFixed = _useState9[1];

  var _useState10 = React.useState([]),
      listFixedBefore = _useState10[0],
      setListFixedBefore = _useState10[1];

  var _useState11 = React.useState([]),
      listVisible = _useState11[0],
      setlistVisible = _useState11[1];

  var calculateList = function calculateList() {
    var newListVisible = [];
    var newListMore = [];
    var newListFixed = []; // Lista elementi fissati (non vanno in more e finiscono in coda a tutto)

    var newListFixedBefore = [];
    var childrenToCollapse = [];
    var gap = parseFloat(getComputedStyle(document.documentElement).fontSize);
    var tol = gap;
    var totSize = elementBarRef.current.offsetWidth;
    var isBefore = true;
    React__default["default"].Children.forEach(children, function (element, index) {
      if (!element) return;

      var _ref2 = element.props || {},
          avoidMore = _ref2.avoidMore,
          restProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);

      var ielem = listInitialElements[index];
      ielem.element = element;

      if (avoidMore === true) {
        totSize -= calcComponentWidth(ielem, gap);
        var el = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, {
          key: idComp + "-fixed-elements-" + index
        }, /*#__PURE__*/React__default["default"].cloneElement(element, _extends({}, restProps, {
          compact: compact
        })));

        if (isBefore) {
          newListFixedBefore.push(el);
        } else {
          newListFixed.push(el);
        }
      } else {
        isBefore = false;
        childrenToCollapse.push(ielem);
      }
    });

    if (newListFixed.length) {
      totSize += gap;
    }

    var moreWidth = moreButtonWidth; // non aggiungo se ci sono bottoni a destra c'è un gap sommato in più per l'ultimo bottone

    if (newListFixed.length) {
      moreWidth += gap;
    }

    childrenToCollapse.forEach(function (ielem, index) {
      var isLast = index === childrenToCollapse.length - 1; // add componentSize to calculated total size
      //calcSize = calcSize + calcComponentWidth(listInitialElements[index], gap);

      var elemWidth = calcComponentWidth(ielem, gap);
      var element = ielem.element;
      if (compact && element && typeof element.type !== 'string') //all the element except base components
        element = /*#__PURE__*/React__default["default"].cloneElement(element, _extends({}, element.props, {
          compact: true
        }));
      var toVisible = false;

      if (totSize > 0) {
        if (isLast) {
          if (totSize >= elemWidth + tol) toVisible = true;
        } else if (totSize - elemWidth - tol > moreWidth) {
          toVisible = true;
        }
      }

      if (toVisible) {
        newListVisible.push( /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, {
          key: idComp + "-elements-" + index
        }, element));
        totSize -= elemWidth;
      } else {
        totSize = 0; //da qui in poi i bottoni andranno in more

        newListMore.push( /*#__PURE__*/React__default["default"].createElement("div", {
          key: idComp + "-moreElement-" + index,
          className: classNamePrefix$f + "-container-moreElement"
        }, element));
      }
    });
    setlistVisible(newListVisible);
    setListMore(newListMore);
    setListFixedBefore(newListFixedBefore);
    setListFixed(newListFixed);
  };

  var calcComponentWidth = function calcComponentWidth(component, gap) {
    var componentSize = 0; // Get Components width from the initialElements

    componentSize = component.width; // add margin-right = 1rem

    componentSize = componentSize + gap;
    return componentSize;
  };

  var onClickButton = function onClickButton() {
    setShowContent(!showContent);
  };

  React.useEffect(function () {
    if (elementBarRef.current && !resizeObserver) {
      //set observer
      var _resizeObserver = new ResizeObserver(function () {
        //Debouncer.debounce(idComp, 50, ()  => setWidth(elementBarRef.current.offsetWidth))
        setWidth(elementBarRef.current.offsetWidth);
      });

      _resizeObserver.observe(elementBarRef.current);

      setResizeObserver(_resizeObserver);
    }

    return function () {
      if (resizeObserver && elementBarRef.current) {
        resizeObserver.unobserve(elementBarRef.current);
        setResizeObserver(null);
      }
    };
  }, [elementBarRef, resizeObserver]);
  React.useEffect(function () {
    calculateList();
  }, [children, width, moreButtonWidth]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: elementBarRef,
    style: {
      alignItems: alignItems
    },
    className: (classNamePrefix$f + " " + barPos + " " + classNameBar).trimEnd()
  }, listFixedBefore, listVisible, listMore && listMore.length !== 0 && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(agui__default["default"].aButton, {
    onClick: onClickButton,
    icon: iconMore
  }, !compact ? labelMore : null), /*#__PURE__*/React__default["default"].createElement(agui__default["default"].PopupContestuale, {
    show: showContent,
    onClose: function onClose() {
      return setShowContent(false);
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    ref: containerRef,
    className: classNamePrefix$f + "-container"
  }, listMore))), listFixed);
}
ElementBar.propTypes = {
  classNameBar: p__default["default"].string,
  compact: p__default["default"].bool,
  labelMore: p__default["default"].string,
  iconMore: p__default["default"].string,
  barPosition: p__default["default"].oneOf(['left', 'right']),
  alignItems: p__default["default"].oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'baseline', 'initial', 'inherit']),
  children: p__default["default"].node
};

var classNamePrefix$e = 'arm-core-layouts-page-header';

function addHash(url) {
  var fChar = url.charAt(0);
  if (fChar === "#") return url;
  if (fChar === "/") return "#" + url;
  return "#/" + url;
}

var BreadCrumbs = function BreadCrumbs(_ref) {
  var elems = _ref.elems;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$e + "-breadcrumbs"
  }, elems.map(function (elem, index) {
    return elems.length !== index + 1 ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, {
      key: "breadcrumb-el-" + index
    }, /*#__PURE__*/React__default["default"].createElement("a", {
      href: !elem.onClick ? addHash(elem.url) : null,
      onClick: elem.onClick
    }, elem.label), /*#__PURE__*/React__default["default"].createElement("i", {
      className: "fas fa-angle-right"
    })) : /*#__PURE__*/React__default["default"].createElement("span", {
      key: "breadcrumb-el-" + index
    }, elem.label);
  }));
};
/** @type {_PageHeader} */


function PageHeader(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      title = props.title,
      breadcrumbs = props.breadcrumbs,
      backurlProp = props.backurl,
      children = props.children;
  var withLink = breadcrumbs || backurl ? "with-link" : "";
  var backurl = {
    url: '',
    label: common.i18n("ARM_CORE_LAYOUTS.PAGE_HEADER.BACK", "Back"),
    onClick: null
  };

  if (backurlProp) {
    if (typeof backurlProp === 'string') {
      backurl.url = backurlProp;
    } else {
      backurl.url = backurlProp.url;
      backurl.label = backurlProp.label || backurl.label; //if not present use default label

      backurl.onClick = backurlProp.onClick;
    }
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: (classNamePrefix$e + " " + withLink + " " + className).trimEnd()
  }, backurl.url && /*#__PURE__*/React__default["default"].createElement("a", {
    className: "backurl",
    href: !backurl.onClick ? addHash(backurl.url) : null,
    onClick: backurl.onClick
  }, /*#__PURE__*/React__default["default"].createElement("i", {
    className: "fas fa-chevron-left"
  }), backurl.label), /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$e + "-content"
  }, title && /*#__PURE__*/React__default["default"].createElement("span", {
    className: "title"
  }, title), breadcrumbs && /*#__PURE__*/React__default["default"].createElement(BreadCrumbs, {
    elems: breadcrumbs
  }), children && /*#__PURE__*/React__default["default"].createElement(ElementBar, {
    classNameBar: classNamePrefix$e + "-bar",
    compact: true
  }, children)));
}
var urlProp = p__default["default"].shape({
  url: p__default["default"].string,
  label: p__default["default"].string,
  onClick: p__default["default"].func
});
PageHeader.propTypes = {
  className: p__default["default"].string,
  title: p__default["default"].string,
  breadcrumbs: p__default["default"].arrayOf(urlProp),
  backurl: p__default["default"].oneOfType([p__default["default"].string, urlProp]),
  children: p__default["default"].node
};

var classNamePrefix$d = 'arm-core-layouts-page-header-container';

function getChildren(children) {
  var verticalComponents = [];
  var horizontalComponents = [];
  React__default["default"].Children.forEach(children, function (child, index) {
    if (child && child.type.toString() === PageFilterPanel.toString()) {
      horizontalComponents.push(child);
    } else {
      verticalComponents.push(child);
    }
  });
  return {
    verticalComponents: verticalComponents,
    horizontalComponents: horizontalComponents
  };
}
/** @type {_PageHeaderContainer} */


function PageHeaderContainer(props) {
  var children = props.children;
  var components = getChildren(children);
  var ref = React.useRef();
  var menuLeftWidth = getMenuLeftWidth(children);

  var _useState = React.useState({
    left: menuLeftWidth
  }),
      style = _useState[0],
      setStyle = _useState[1];

  var leftBarStyle = {
    paddingRight: components.horizontalComponents.length > 0 ? '3%' : '0%'
  };
  React.useEffect(function () {
    var newStyle = {
      left: menuLeftWidth
    };

    if (ref.current) {
      setTimeout(function () {
        var _ref$current$getBound = ref.current.getBoundingClientRect(),
            height = _ref$current$getBound.height;

        newStyle.height = height;
        setStyle(newStyle);
      }, 25);
    }
  }, [ref, children, menuLeftWidth]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: ref,
    className: "" + classNamePrefix$d,
    style: style
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$d + "-left",
    style: leftBarStyle
  }, components.verticalComponents.map(function (child, index) {
    return child;
  }), components.horizontalComponents.length > 0 && /*#__PURE__*/React__default["default"].createElement("svg", {
    id: "svg-divisor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "none"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    fill: "white",
    points: "90,0 100,0 10,100 0,100"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    id: "filter-panel",
    points: "100,0 100,100 10,100"
  }))), components.horizontalComponents.map(function (child, index) {
    return child;
  }));
}

PageHeaderContainer.propTypes = {
  children: p__namespace.node.isRequired
};
PageHeaderContainer.PageHeader = PageHeader;

var classNamePrefix$c = 'arm-core-layouts-page-filter';
/** @type {_PageFilter} */

function PageFilter(props) {
  console.log('[PageFilter.jsx]: render');
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      children = props.children;
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement(PageFilterDivider, null), /*#__PURE__*/React__namespace.createElement("div", {
    className: classNamePrefix$c + " " + className
  }, children));
}
PageFilter.propTypes = {
  className: p__namespace.string
};
/** @type {_PageFilterGroup} */

function PageFilterGroup(props) {
  var _props$className2 = props.className,
      className = _props$className2 === void 0 ? '' : _props$className2,
      _props$right = props.right,
      right = _props$right === void 0 ? false : _props$right,
      _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      children = props.children;

  if (right) {
    return /*#__PURE__*/React__namespace.createElement(ElementBar, {
      compact: true,
      alignItems: alignItems,
      classNameBar: classNamePrefix$c + "-group " + className
    }, children);
  }

  return /*#__PURE__*/React__namespace.createElement("div", {
    style: {
      alignItems: alignItems
    },
    className: classNamePrefix$c + "-group " + className
  }, React__namespace.Children.map(props.children, function (child) {
    if (child && typeof child.type !== 'string') {
      //all the element except base components
      return /*#__PURE__*/React__namespace.cloneElement(child, _extends({}, child.props, {
        compact: true
      }));
    } else {
      return child;
    }
  }));
}

PageFilterGroup.propTypes = {
  className: p__namespace.string,
  right: p__namespace.bool,
  alignItems: p__namespace.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'baseline', 'initial', 'inherit']),
  children: p__namespace.node
};

var PageFilterDivider = function PageFilterDivider() {
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: classNamePrefix$c + "-divisor"
  }, /*#__PURE__*/React__namespace.createElement("div", null));
};

PageFilter.Group = PageFilterGroup;

var classNamePrefix$b = 'arm-core-layouts-page-body';
function PageBody(props) {
  console.log('[PageBody]: render');
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      children = props.children;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: (classNamePrefix$b + " " + className).trimEnd()
  }, children);
}
PageBody.propTypes = {
  className: p__namespace.string,
  children: p__namespace.node
};

var classNamePrefix$a = 'arm-core-layouts-page-footer';
function PageFooter(props) {
  console.log('[PageFooter]: render');
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      children = props.children;
  var ref = React.useRef();
  var menuLeftWidth = getMenuLeftWidth(children);

  var _useState = React.useState({
    left: menuLeftWidth
  }),
      style = _useState[0],
      setStyle = _useState[1];

  React.useEffect(function () {
    var newStyle = {
      left: menuLeftWidth
    };

    if (ref.current) {
      setTimeout(function () {
        var _ref$current$getBound = ref.current.getBoundingClientRect(),
            height = _ref$current$getBound.height;

        newStyle.height = height;
        setStyle(newStyle);
      }, 25);
    }
  }, [ref, children, menuLeftWidth]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: ref,
    style: style,
    className: (classNamePrefix$a + " " + className).trimEnd()
  }, children);
}
PageFooter.propTypes = {
  className: p__namespace.string,
  children: p__namespace.node
};
function PageFooterGroup(props) {
  console.log('[PageFooterGroup]: render');
  var _props$className2 = props.className,
      className = _props$className2 === void 0 ? '' : _props$className2,
      children = props.children;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: (classNamePrefix$a + "-group " + className).trimEnd()
  }, children);
}
PageFooterGroup.propTypes = {
  className: p__namespace.string,
  children: p__namespace.node
};

var classNamePrefix$9 = 'arm-core-layouts-spinner';
/**
 * Spinner rendering 
 * 
 * @param {object} props Spinner properties
 * @param {string} [props.className] SidePopup selector
 * @param {Node} [props.children] React.children uses to add content on bottom of spinner circle
 * @returns {JSX.Element}
 */

function Spinner(props) {
  console.log('[Spinner]: render');
  var className = props.className,
      children = props.children;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: (classNamePrefix$9 + "-container " + className).trimEnd()
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    className: "" + classNamePrefix$9,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React__default["default"].createElement("circle", {
    className: classNamePrefix$9 + "-path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "5"
  })), children);
}
Spinner.propTypes = {
  className: p__namespace.string
};

/**
 * @typedef {object} SidePopupProps SidePopup properties
 * @prop {boolean} visible show/hide SidePopup
 * @prop {('right'|'left')} [side='right'] side of popup
 * @prop {boolean} [loading=false] show/hide loader
 * @prop {string} [loadingMessage] text of loader
 * @prop {boolean} [useReduce=false] show/hide reduce button
 * @prop {('SMALL'|'MEDIUM'|'LARGE'|'XLARGE')} [size='MEDIUM'] popup size
 * @prop {Function} [onClose] function that close popup
 * @prop {string} [className] SidePopup selector
 * @prop {Node} [children] React.children
 */

/**
 * Component that render a modal on left or right of the screen
 * 
 * @callback _SidePopup
 * @param {SidePopupProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} SidePopupHeaderProps SidePopup.header properties
 * @prop {string} [title] SidePopupHeader title
 * @prop {('row'|'column')} [contentDirection='row'] direction of elements in header
 * @prop {string} [className] SidePopupHeader selector to add
 * @prop {Node} [children] React.children
 */

/**
 * Header of SidePopup
 * 
 * @callback _SidePopupHeader
 * @param {SidePopupHeaderProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} SidePopupComponentProps SidePopup.body/SidePopup.footer properties
 * @prop {string} [title] SidePopupHeader title
 * @prop {string} [className] SidePopupHeader selector to add
 * @prop {Node} [children] React.children
 */

/**
 * @callback _SidePopupComponent
 * @param {SidePopupComponentProps} props
 * @returns {JSX.Element}
 */
exports.typedef = {};

var classNamePrefix$8 = 'arm-core-layouts-side-popup';
var SidePopupId = 1;
/** @type {_SidePopup} */

function SidePopup(props) {
  var _props$side = props.side,
      side = _props$side === void 0 ? 'right' : _props$side,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$useReduce = props.useReduce,
      useReduce = _props$useReduce === void 0 ? false : _props$useReduce,
      size = props.size,
      visible = props.visible,
      onClose = props.onClose,
      children = props.children,
      className = props.className,
      loadingMessage = props.loadingMessage;

  var _useState = React.useState(false),
      reduced = _useState[0],
      setReduced = _useState[1];

  var _useState2 = React.useState(false),
      doRender = _useState2[0],
      setDoRender = _useState2[1];

  var _useState3 = React.useState(classNamePrefix$8 + "-" + SidePopupId++),
      baseId = _useState3[0];

  var closePopup = function closePopup() {
    setReduced(false);
    onClose();
  };

  var headId = baseId + "-header";
  var popupId = baseId + "-popup";
  var iconPosition = reduced ? side === 'right' ? 'left' : 'right' : side === 'right' ? 'right' : 'left';
  var sizeClz = " size-" + (size || "MEDIUM").toLowerCase() + " ";
  var clzName = (className || '') + sizeClz + (useReduce ? classNamePrefix$8 + "-has-reduce" : '');

  var reduceClick = function reduceClick(e) {
    e.preventDefault();

    if (useReduce) {
      setReduced(!reduced);
      var sidePopup = document.getElementById(popupId);
      var md = sidePopup.getElementsByClassName(classNamePrefix$8 + "-modal-dialog")[0];

      if (!reduced) {
        var w = md.getBoundingClientRect().width; // .style.width.replace("px", ""));

        md.style[side] = -w + 40 + "px";
      } else {
        md.style = {};
      }
    }
  }; // show/hide diretto:
  // const doRender  = visible;


  if (visible) {
    if (!doRender) {
      setDoRender(true);
      var tryget = setInterval(function () {
        var sp = document.getElementById(popupId);

        if (sp) {
          sp.className += " in ";
          clearInterval(tryget);
        }
      }, 140);
    } else {
      if (clzName.indexOf(" in ") < 0) clzName += " in ";
    }
  } else {
    if (doRender) {
      var sp = document.getElementById(popupId);

      if (sp) {
        var clz = sp.className;
        clz = clz.replace(/ in /g, " ");
        sp.className = clz;
        setTimeout(function () {
          setDoRender(false);
        }, 300);
      }
    }
  }

  return /*#__PURE__*/React__default["default"].createElement(agui.ModalContainer, null, doRender && /*#__PURE__*/React__default["default"].createElement("div", {
    id: popupId,
    className: (classNamePrefix$8 + " show fade " + clzName + " " + side).trimEnd(),
    tabIndex: "-1",
    role: "dialog",
    "aria-labelledby": headId,
    onClick: closePopup
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: classNamePrefix$8 + "-modal-dialog",
    role: "document"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$8 + "-modal-content"
  }, onClose && /*#__PURE__*/React__default["default"].createElement("button", {
    type: "button",
    className: classNamePrefix$8 + "-close",
    "data-dismiss": "modal",
    "aria-label": common.i18n('ARM_CORE_LAYOUTS.SIDE_POPUP.CLOSE', 'Chiudi'),
    onClick: closePopup
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), useReduce && /*#__PURE__*/React__default["default"].createElement(ReduceIcon, {
    position: iconPosition,
    className: classNamePrefix$8 + "-reduce-" + side,
    onClick: reduceClick
  }), loading && /*#__PURE__*/React__default["default"].createElement(Spinner, {
    className: classNamePrefix$8 + "-spinner"
  }, loadingMessage), children), " "))
  /* -- modal -- */
  );
}
/** @type {_SidePopupHeader} */

function ModalHeader(_ref) {
  var title = _ref.title,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$contentDirection = _ref.contentDirection,
      contentDirection = _ref$contentDirection === void 0 ? 'row' : _ref$contentDirection,
      children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: (classNamePrefix$8 + "-modal-header " + classNamePrefix$8 + "-modal-header-" + contentDirection + " " + className).trimEnd()
  }, title && /*#__PURE__*/React__default["default"].createElement("span", {
    className: classNamePrefix$8 + "-modal-title"
  }, title), /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$8 + "-modal-header-content"
  }, children));
}

ModalHeader.propTypes = {
  title: p__namespace.string,
  contentDirection: p__namespace.oneOf(['row', 'column']),
  className: p__namespace.string,
  children: p__namespace.node
};
/** @type {_SidePopupComponent} */

function ModalBody(_ref2) {
  var className = _ref2.className,
      children = _ref2.children;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: (classNamePrefix$8 + "-modal-body " + (className || "")).trimEnd()
  }, " ", children, " ");
}

ModalBody.propTypes = {
  className: p__namespace.string,
  children: p__namespace.node
};
/** @type {_SidePopupComponent} */

function ModalFooter(_ref3) {
  var className = _ref3.className,
      children = _ref3.children;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$8 + "-modal-footer " + (className || "")
  }, " ", children, " ");
}

ModalFooter.propTypes = {
  className: p__namespace.string,
  children: p__namespace.node
};
SidePopup.propTypes = {
  visible: p__namespace.bool.isRequired,
  side: p__namespace.oneOf(["left", "right"]),
  size: p__namespace.oneOf(['SMALL', 'MEDIUM', 'LARGE', 'XLARGE']),
  loading: p__namespace.bool,
  loadingMessage: p__namespace.string,
  useReduce: p__namespace.bool,
  onClose: p__namespace.func,
  children: p__namespace.node
};
SidePopup.header = ModalHeader;
SidePopup.body = ModalBody;
SidePopup.footer = ModalFooter;

var VBox = function VBox(props) {
  console.log('[VBox.jsx]: render');
  var id = props.id,
      className = props.className,
      style = props.style,
      children = props.children;
  var idDiv = common__default["default"].Utils.uuid('VBox');

  if (id) {
    idDiv = props.id;
  }

  var clsName = ' arm-core-layouts-VBox ';

  if (className) {
    clsName += className;
  }

  var inlineStyle = {};

  if (style) {
    inlineStyle = style;
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: idDiv,
    className: clsName,
    style: inlineStyle
  }, children);
};

VBox.propTypes = {
  id: p__namespace.string,
  className: p__namespace.string,
  style: p__namespace.object,
  children: p__namespace.node
};

var HBox = function HBox(props) {
  console.log('[HBox.jsx]: render');
  var id = props.id,
      className = props.className,
      style = props.style,
      children = props.children;
  var idDiv = common__default["default"].Utils.uuid('HBox');

  if (id) {
    idDiv = props.id;
  }

  var clsName = ' arm-core-layouts-HBox ';

  if (className) {
    clsName += className;
  }

  var inlineStyle = {};

  if (style) {
    inlineStyle = style;
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: idDiv,
    className: clsName,
    style: inlineStyle
  }, children);
};

HBox.propTypes = {
  id: p__namespace.string,
  className: p__namespace.string,
  style: p__namespace.object,
  children: p__namespace.node
};

var name = "arm-core-layouts";
var version = "0.11.2";
var author = "Armundia Group";
var homepage = "http://www.armundia.com";
var license = "Armundia";
var main = "./dist/main/index.js";
var files = [
	"dist"
];
var devDependencies = {
	"arm-common": "1.0.5",
	"arm-file-uploader": "2.3.0",
	"arm-gui": "4.2.1",
	"arm-gulp-builders": "2.1.1",
	"arm-router": "1.3.0",
	"arm-themes": "^1.2.2-beta.0",
	"arm-visual-component": "2.2.0",
	"babel-eslint": "10.0.3",
	"eslint-plugin-import": "2.22.0",
	"eslint-plugin-react": "7.20.3",
	"immutability-helper": "^3.1.1",
	react: "16.13.1",
	"react-dom": "16.13.1",
	"react-router-dom": "5.2.0",
	"react-redux": "^7.2.0",
	redux: "^4.0.5",
	"redux-thunk": "^2.3.0"
};
var peerDependencies = {
	"arm-common": ">=1.0.3 <2.0.0-0",
	"arm-gui": ">=3.5.0 <5.0.0-0",
	"arm-router": ">=1.3.0 <2.0.0-0"
};
var dependencies = {
	"react-transition-group": "4.4.2",
	"prop-types": "15.7.2"
};
var scripts = {
	publishVersion: "gulp npm && npm publish",
	patch: "npm version patch && gulp npm && npm publish",
	minor: "npm version minor && gulp npm && npm publish",
	major: "npm version major && gulp npm && npm publish",
	"pre-release": "npm version prerelease && gulp npm && npm publish --tag=beta",
	"pre-patch": "npm version prepatch && gulp npm && npm publish --tag=beta",
	"pre-minor": "npm version preminor && gulp npm && npm publish --tag=beta",
	"pre-major": "npm version premajor && gulp npm && npm publish --tag=beta",
	watch: "gulp watch"
};
var publishConfig = {
	registry: "https://nexus.armundia.com/repository/npm-releases"
};
var pckg = {
	name: name,
	version: version,
	author: author,
	homepage: homepage,
	license: license,
	main: main,
	files: files,
	devDependencies: devDependencies,
	peerDependencies: peerDependencies,
	dependencies: dependencies,
	scripts: scripts,
	publishConfig: publishConfig
};

var warn = function warn(msg, val) {
  return console.warn("[WizardStore]: " + msg, val);
};
/** 
 * Store of WizardItem to communicate with WizardProcess
*/


var items = {};
/**
 * @typedef {Object} WizardItem properties of WizardItem
 * @property {string} id identifier component
 * @property {string} title label showed in tooltip
 * @property {string} className optional element selector
 * @property {number} number of item
 * @property {boolean} disabled
 * @property {boolean} visible
 * @property {boolean} open
 * @property {Function} openContent to open the content of item
 */

/**
 * 
 * @param {string} id WizardItem id
 * @param {WizardItem} itemProps 
 */

function addItem(id, itemProps) {
  if (items[id]) return warn("item alredy present", items[id]);
  items[id] = itemProps;
}
/**
 * @param {string} id WizardItem id
 */


function getItem(id) {
  if (!items[id]) warn("item with such id is not exist", id);
  return items[id];
}
/**
 * @param {string} id WizardItem id
 */


function deleteItem(id) {
  if (!items[id]) return warn("item with such id is not exist", id);
  delete items[id];
}

var classNamePrefix$7 = "arm-core-layouts-wizard-item";

function WizardFooter(props) {
  console.log('[WizardFooter]: render');
  var id = props.id,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      children = props.children;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: id,
    className: (classNamePrefix$7 + "-footer " + className).trim()
  }, children);
}

WizardFooter.propTypes = {
  id: p__namespace.string,
  className: p__namespace.string,
  children: p__namespace.node
};

var WizardTitle = function WizardTitle(_ref) {
  var title = _ref.title,
      onOpen = _ref.onOpen,
      number = _ref.number,
      open = _ref.open,
      iconOpen = _ref.iconOpen,
      iconClosed = _ref.iconClosed;
  return !title && !onOpen ? null : /*#__PURE__*/React__default["default"].createElement("div", {
    className: number === 1 ? classNamePrefix$7 + "-title " + classNamePrefix$7 + "-title-first" : classNamePrefix$7 + "-title"
  }, number && /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$7 + "-title-circle-sign"
  }, /*#__PURE__*/React__default["default"].createElement("h6", null, number)), /*#__PURE__*/React__default["default"].createElement("h5", null, title), open !== undefined && onOpen && /*#__PURE__*/React__default["default"].createElement("i", {
    className: classNamePrefix$7 + "-title-icon " + (!open ? iconOpen || "fas fa-plus" : iconClosed || "fas fa-minus"),
    onClick: onOpen
  }));
};

function WizardItem(props) {
  console.log('[WizardItem]: render');
  var id = props.id,
      _props$className2 = props.className,
      className = _props$className2 === void 0 ? '' : _props$className2,
      number = props.number,
      title = props.title,
      children = props.children,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      visible = props.visible,
      open = props.open,
      onOpen = props.onOpen;
  if (visible !== undefined && !visible) return null;
  React.useEffect(function () {
    var propsCopy = _extends({}, props);

    propsCopy.openContent = function () {
      return onOpen && onOpen(true);
    };

    addItem(id, propsCopy);
    return function () {
      return deleteItem(id);
    };
  }, [open, disabled]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: id,
    className: (classNamePrefix$7 + " " + className).trim()
  }, /*#__PURE__*/React__default["default"].createElement(WizardTitle, {
    number: number,
    title: title,
    onOpen: onOpen,
    open: open
  }), /*#__PURE__*/React__default["default"].createElement(agui__namespace.aCard, {
    className: (classNamePrefix$7 + "-card " + (disabled ? classNamePrefix$7 + '-card-disabled' : '')).trim(),
    visible: open
  }, /*#__PURE__*/React__default["default"].createElement(agui__namespace.aCardBody, null, children)));
}
WizardItem.propTypes = {
  id: p__namespace.string,
  className: p__namespace.string,
  number: p__namespace.number,
  title: p__namespace.string,
  disabled: p__namespace.bool,
  visible: p__namespace.bool,
  open: p__namespace.bool,
  onOpen: p__namespace.func,
  children: p__namespace.node
};
WizardItem.Footer = WizardFooter;

var _excluded = ["id", "className", "title", "onConfirm", "icon", "children"];
var idCounter$1 = 0;
var classNamePrefix$6 = 'arm-core-wizard-confirm';

function WizardConfirm(props) {
  console.log('[WizardConfirm]: render');

  var _props$id = props.id,
      id = _props$id === void 0 ? classNamePrefix$6 + "-" + idCounter$1++ : _props$id,
      className = props.className,
      title = props.title,
      onConfirm = props.onConfirm,
      icon = props.icon;
      props.children;
      var wizardItemProps = _objectWithoutPropertiesLoose(props, _excluded);

  var _useState = React.useState(id),
      idComp = _useState[0];

  return /*#__PURE__*/React__default["default"].createElement(WizardItem, _extends({
    id: idComp,
    className: (classNamePrefix$6 + " " + (className || '')).trim(),
    title: title
  }, wizardItemProps), /*#__PURE__*/React__default["default"].createElement(HBox, {
    className: classNamePrefix$6 + "-box"
  }, /*#__PURE__*/React__default["default"].createElement(controls.aButton, {
    className: classNamePrefix$6 + "-btn",
    bs: "primary",
    inline: true,
    icon: icon,
    onClick: onConfirm
  }, title)));
}

WizardConfirm.propTypes = _extends({
  id: p__namespace.string,
  className: p__namespace.string,
  title: p__namespace.string,
  onConfirm: p__namespace.func,
  icon: p__namespace.string
}, WizardItem.propTypes);

var classNamePrefix$5 = "arm-core-layouts-wizard-process";
var defaultOffset = 0;
/**
 * Javascript helper to scroll and position the window over an element with a id
 * 
 * @param {string} id id of element (without #)
 */

function moveTo(id) {
  scrollToId(id, defaultOffset);
}

function scrollToId(id, yOffset) {
  var _this = this;

  var element = document.querySelector("#" + id);

  if (element) {
    var y = element.getBoundingClientRect().top + window.pageYOffset + (yOffset || defaultOffset);
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  } else {
    setTimeout(function () {
      return _this.scrollToId(id, yOffset);
    }, 100);
  }
}

function WizardProcess(props) {
  console.log('[WizardProcess]: render');
  var currRef = React.useRef(null);

  var _useState = React.useState(false),
      ticking = _useState[0],
      setTicking = _useState[1];

  var _useState2 = React.useState(window.scrollY),
      windowPosition = _useState2[0],
      setWP = _useState2[1];

  var _useState3 = React.useState(0),
      prevElemPos = _useState3[0],
      setPrevElemPos = _useState3[1];

  var _useState4 = React.useState(0),
      posInDom = _useState4[0],
      setPos = _useState4[1]; //To optimize scroll update


  var onScroll = function onScroll() {
    var lastPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(function () {
        setTicking(false);
        setWP(lastPosition);
      });
      setTicking(true);
    }
  };

  React.useEffect(function () {
    window.scrollTo({
      top: 0
    });
    window.addEventListener('scroll', onScroll);

    if (currRef.current) {
      setPrevElemPos(currRef.current.getBoundingClientRect().top);
      defaultOffset = -(currRef.current.getBoundingClientRect().bottom + 1);
      setPos(currRef.current.getBoundingClientRect().bottom + 1);
    }
    return function () {
      return window.removeEventListener('scroll', onScroll);
    };
  }, [currRef.current]);
  var elements = props.elements;
  var size = elements == null ? void 0 : elements.length;

  if (!elements || size === 0) {
    return null;
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: currRef,
    className: classNamePrefix$5,
    style: {
      top: prevElemPos
    }
  }, elements.map(function (elem, index) {
    var elemPosition = 0;
    if (document.querySelector("#" + elem.id)) elemPosition = document.querySelector("#" + elem.id).getBoundingClientRect().top - posInDom + windowPosition;
    var isSelected = Math.floor(windowPosition) >= Math.floor(elemPosition);

    if (index + 1 < size) {
      var nextElem = elements[index + 1];
      var nextElemPosition = 0;
      if (document.querySelector("#" + nextElem.id)) nextElemPosition = document.querySelector("#" + nextElem.id).getBoundingClientRect().top - posInDom + windowPosition;
      isSelected = windowPosition >= elemPosition && windowPosition < nextElemPosition;
    }

    var className = classNamePrefix$5 + "-circle-sign";
    if (elem.isWC) className = classNamePrefix$5 + "-wizard-confirm";
    if (isSelected) className += " " + classNamePrefix$5 + "-selected";
    return /*#__PURE__*/React__default["default"].createElement("div", {
      "data-balloon-pos": 'down',
      "data-balloon": elem.title || "",
      "data-balloon-break": true,
      key: classNamePrefix$5 + "-" + elem.id,
      className: className,
      onClick: function onClick() {
        var wizardItem = getItem(elem.id);
        wizardItem.openContent();
        setTimeout(function () {
          return scrollToId(elem.id, -posInDom);
        }, 200);
      }
    }, index !== 0 && /*#__PURE__*/React__default["default"].createElement("div", {
      className: isSelected ? classNamePrefix$5 + "-bar " + classNamePrefix$5 + "-selected" : classNamePrefix$5 + "-bar"
    }), index + 1);
  }));
}

var classNamePrefix$4 = 'arm-core-layouts-wizard';
var idCounter = 0;

function Wizard(props) {
  console.log('[Wizard]: render');
  var _props$id = props.id,
      id = _props$id === void 0 ? "wizard-" + idCounter++ : _props$id,
      className = props.className,
      children = props.children;

  var _useState = React.useState(id),
      idComp = _useState[0];

  React.useEffect(function () {
    document.getElementsByClassName('arm-core-layouts-application-container-body')[0].classList.add(classNamePrefix$4 + "-body");
    return function () {
      return document.getElementsByClassName('arm-core-layouts-application-container-body')[0].classList.remove(classNamePrefix$4 + "-body");
    };
  }, []);
  var elements = [];
  var wizardItems = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].Children.map(children, function (child, index) {
    if (child.type.toString() === Wizard.Item.toString() || child.type.toString() === Wizard.Confirm.toString()) {
      var childProps = _extends({}, child.props);

      childProps.id = childProps.id || id + "-item-" + index;
      childProps.number = index + 1;
      elements.push({
        id: childProps.id,
        title: childProps.title,
        open: childProps.open,
        isWC: child.type.toString() === Wizard.Confirm.toString()
      });
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(child.type, childProps));
    } else {
      console.warn("[Wizard]: accept only WizardItem component", child.type.toString());
    }
  }));
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    id: idComp,
    className: (classNamePrefix$4 + " " + (className || '')).trim()
  }, /*#__PURE__*/React__default["default"].createElement(WizardProcess, {
    elements: elements
  }), wizardItems), /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$4 + "-background"
  }));
}
Wizard.propTypes = {
  id: p__namespace.string,
  className: p__namespace.string,
  children: p__namespace.node
};
Wizard.Item = WizardItem;
Wizard.Confirm = WizardConfirm;
Wizard.moveTo = moveTo;

var classNamePrefix$3 = 'arm-core-layouts-auto-size';
/**
 * @param {number} rem 
 * @returns {number} calculated pixel size
 */

function convertRemToPixels(rem) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}
/**
 * @param {HTMLElement} element dom element
 * @param {('x'|'y')} axis
 * @returns {number} total space of element
 */


function getAxisSizesFromElement(element, axis) {
  if (!element) return 0;
  var computedStyle = window.getComputedStyle(element);
  var size = 0;

  switch (axis) {
    case 'x':
      var valuesX = ['padding-right', 'margin-right'];
      valuesX.forEach(function (val) {
        size += parseFloat(computedStyle.getPropertyValue(val));
      });
      break;

    case 'y':
      var valuesY = ['padding-bottom', 'margin-bottom'];
      valuesY.forEach(function (val) {
        size += parseFloat(computedStyle.getPropertyValue(val));
      });
      break;
  }

  return size;
}
/**
 * Component that helps to get remaining space of window
 * 
 * @param {object} props - AutoSize properties
 * @param {boolean} [props.height=true] - get the remaining height
 * @param {boolean} [props.width=true] - get the remaining width
 * @param {number} [props.offsetHeight] - remaining height less the offset choosen
 * @param {number} [props.offsetWidth] - remaining width less the offset choosen
 * @param {boolean} [props.overflow] - can overflow the container
 *  
 * @returns {JSX.Element}
 */


function AutoSize(props) {
  console.log('[AutoSize]: render');
  var className = props.className,
      _props$height = props.height,
      height = _props$height === void 0 ? true : _props$height,
      _props$width = props.width,
      width = _props$width === void 0 ? true : _props$width,
      _props$offsetHeight = props.offsetHeight,
      offsetHeight = _props$offsetHeight === void 0 ? 0 : _props$offsetHeight,
      _props$offsetWidth = props.offsetWidth,
      offsetWidth = _props$offsetWidth === void 0 ? 0 : _props$offsetWidth,
      children = props.children,
      overflow = props.overflow;

  var _useState = React.useState({}),
      style = _useState[0],
      setStyle = _useState[1];

  var _useState2 = React.useState(false),
      ready = _useState2[0],
      isReady = _useState2[1];

  var ref = React.useRef();

  var setSizes = function setSizes() {
    if (ref.current) {
      var _ref$current$getBound = ref.current.getBoundingClientRect(),
          top = _ref$current$getBound.top,
          left = _ref$current$getBound.left;

      var h, w;
      h = w = null;
      var overflowX, overflowY;
      overflowX = overflowY = overflow ? 'hidden' : null;

      if (height) {
        h = window.innerHeight - top - offsetHeight - getAxisSizesFromElement(ref.current.parentElement, 'y');

        if (overflow) {
          overflowY = 'auto';
        }
      }

      if (width) {
        w = window.innerWidth - left - offsetWidth - getAxisSizesFromElement(ref.current.parentElement, 'x');

        if (overflow) {
          overflowX = 'auto';
        }
      }

      setStyle({
        height: h,
        width: w,
        overflowX: overflowX,
        overflowY: overflowY
      });
      isReady(true);
    }
  };

  React.useEffect(function () {
    setTimeout(setSizes, 50);
    window.addEventListener('resize', setSizes);
    return function cleanUp() {
      isReady(false);
      window.removeEventListener('resize', setSizes);
    };
  }, [ref, offsetHeight, offsetWidth]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: ref,
    style: style,
    className: (classNamePrefix$3 + " " + (className || '')).trim()
  }, ready && children);
}
AutoSize.propTypes = {
  className: p__namespace.string,
  height: p__namespace.bool,
  width: p__namespace.bool,
  offsetHeight: p__namespace.number,
  offsetWidth: p__namespace.number,
  children: p__namespace.node
};
AutoSize.convertRemToPixels = convertRemToPixels;

/**
 * @typedef {object} ContainerProps Container properties
 * @prop {string} [className] additional css class name
 * ```jsx
 * <Form.Container className='my-form'>
 *    ...
 * </Form.Container>
 * ```
 * @prop {Node} [children] React.children
 */

/**
 * Component that contains Form Group and 
 * other html elements
 * ```jsx
 * <Form.Container className='my-form'>
 *    <Form.Group>
 *       <Form.Item maxChar={25}> 
 *          <agui.aTextInput ... />
 *       </Form.Item> 
 *    </Form.Group>
 * </Form.Container>
 * ```
 * @callback _Container
 * @param {ContainerProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} GroupProps Form.Group properties
 * @prop {string} [className] additional css class name
 * @prop {string} [legend] eventually legend element
 * @prop {boolean} [full] Group take full width 
 * @prop {boolean} [compact] Group take as much as little space (flex-grow: 0)
 * @prop {boolean} [noWrap] Group has no wrap form item inside (and horizontal gap will be half than default)
 * @prop {boolean} [asCommand] Group take full width and item alignment and background is for form item into typical command section
 * @prop {boolean} [largeGap] Group will be with large gap between form item
 * @prop {Node} [children] React.children
 */

/**
 * Component that contains group of Form Item.
 * 
 * @callback _Group
 * @param {GroupProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} SubGroupProps Form.Group properties
 * @prop {string} [className] additional css class name
 * @prop {boolean} [full] Group take full width 
 * @prop {boolean} [compact] Group take as much as little space (flex-grow: 0)
 * @prop {boolean} [noWrap] Group has no wrap form item inside (and horizontal gap will be half than default)
 * @prop {Node} [children] React.children
 */

/**
 * Subgroup of Form.Group component. It contains a group of Form.Item.
 * 
 * @callback _SubGroup
 * @param {SubGroupProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} ItemGroupProps Form.ItemGroup properties
 * @prop {string} [className] additional css class name
 * @prop {string} [legend] eventually legend element
 * @prop {boolean} [full] ItemGroup take full width 
 * @prop {boolean} [asCommand] ItemGroup take full width and item alignment and background is for form item into typical command section
 * @prop {boolean} [largeGap] ItemGroup will be with large gap between form item
 * @prop {Node} [children] React.children (Form.Item elements)
 */

/**
 * Component that contains group of Form Item.
 * 
 * @callback _ItemGroup
 * @param {ItemGroupProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} ItemProps Form.Item properties
 * @prop {string} [className] additional css class name
 * @prop {boolean} [fixed] Item will be as large as inner (children) width (do not try to fill remain space).
 * @prop {boolean} [full] Item take full (100%) width 
 * @prop {number} [minCharWidth] min character width
 * @prop {number} [maxCharWidth] max character width
 * @prop {number} [fixedCharWidth] fixed width in character 
 * @prop {number} [defaultCharWidth] default initial (preferred) width in character 
 * @prop {boolean} [withEmptyLabel] adding empty label before children item (for align purpose)
 * @prop {Node} [children] React.children
 */

/**
 * Component that contains single Form Item
 * 
 * @callback _Item
 * @param {ItemProps} props
 * @returns {JSX.Element}
 */
exports.typedef = {};

var classNamePrefix$2 = 'arm-core-layouts-form';
var charUnit$1 = "em"; // ch? em?

var charFactor = .6;
var flexGapSupported$1 = null;

function isFlexGapSupported$1() {
  if (flexGapSupported$1 !== null) {
    return flexGapSupported$1;
  } // create flex container with row-gap set


  var flex = document.createElement("div");
  flex.style.display = "flex";
  flex.style.flexDirection = "column";
  flex.style.rowGap = "1px"; // create two, elements inside it

  flex.appendChild(document.createElement("div"));
  flex.appendChild(document.createElement("div")); // append to the DOM (needed to obtain scrollHeight)

  document.body.appendChild(flex);
  var isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap

  flex.parentNode.removeChild(flex);
  flexGapSupported$1 = isSupported;
  return isSupported;
}
/** @type {_Container} */


function Container(props) {
  var children = props.children,
      className = props.className,
      visible = props.visible,
      maxWidth = props.maxWidth;

  if (visible !== undefined && !visible) {
    return null;
  } // TODO check children is a Item or array of ItemGroup or SubGroup


  var extraCls = "";

  if (className) {
    extraCls += " " + className;
  }

  var isGapSupported = isFlexGapSupported$1();

  if (!isGapSupported) {
    extraCls += " " + (classNamePrefix$2 + "-gap-not-supported");
  }

  var extraStyle = {};

  if (maxWidth) {
    extraStyle.maxWidth = "" + maxWidth + ""; // rem?
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$2 + "-container" + extraCls,
    style: extraStyle
  }, children);
}
/** @type {_Group} */


function Group$1(props) {
  var children = props.children,
      legend = props.legend,
      full = props.full,
      asCommand = props.asCommand,
      className = props.className,
      noWrap = props.noWrap,
      compact = props.compact,
      visible = props.visible;

  if (visible !== undefined && !visible) {
    return null;
  }

  var extraCls = "";

  if (legend) {
    extraCls += " with-legend";
  }

  if (full) {
    extraCls += " " + classNamePrefix$2 + "-group-full";
  }

  if (compact) {
    extraCls += " group-compact";
  }

  if (asCommand) {
    extraCls += " " + classNamePrefix$2 + "-group-commands";
  } // was if (largeGap) {
  //   extraCls += " " + classNamePrefix + "-group-largegap";
  // }


  if (className) {
    extraCls += " " + className;
  }

  if (noWrap) {
    extraCls += " " + classNamePrefix$2 + "-group-nowrap";
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$2 + "-group" + extraCls
  }, legend && /*#__PURE__*/React__default["default"].createElement("h4", {
    className: classNamePrefix$2 + '-group-legend',
    title: legend
  }, legend), children);
}
/** @type {_SubGroup} */


function SubGroup(props) {
  var children = props.children,
      full = props.full,
      className = props.className,
      noWrap = props.noWrap,
      compact = props.compact,
      visible = props.visible;

  if (visible !== undefined && !visible) {
    return null;
  }

  var extraCls = "";

  if (full) {
    extraCls += " " + classNamePrefix$2 + "-subgroup-full";
  }

  if (compact) {
    extraCls += " subgroup-compact";
  }

  if (className) {
    extraCls += " " + className;
  }

  if (noWrap) {
    extraCls += " " + classNamePrefix$2 + "-subgroup-nowrap";
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$2 + "-subgroup" + extraCls
  }, children);
}
/** @type {_ItemGroup} */


function ItemGroup(props) {
  var children = props.children,
      legend = props.legend,
      full = props.full;
      props.asCommand;
      var className = props.className,
      largeGap = props.largeGap;
      props.noWrap;
      var visible = props.visible;

  if (visible !== undefined && !visible) {
    return null;
  } // TODO check children is a Item or array of Item


  var extraCls = "";

  if (legend) {
    extraCls += " with-legend";
  }

  if (full) {
    extraCls += " " + classNamePrefix$2 + "-itemgroup-full";
  }

  if (largeGap) {
    extraCls += " " + classNamePrefix$2 + "-itemgroup-largegap";
  }

  if (className) {
    extraCls += " " + className;
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$2 + "-itemgroup" + extraCls
  }, legend && /*#__PURE__*/React__default["default"].createElement("h4", {
    className: classNamePrefix$2 + '-itemgroup-legend',
    title: legend
  }, legend), children);
}

function toWidth(val) {
  return "" + val * charFactor + "" + charUnit$1;
}
/** @type {_Item} */


function Item$1(props) {
  var children = props.children,
      fixed = props.fixed,
      full = props.full,
      className = props.className,
      minCharWidth = props.minCharWidth,
      maxCharWidth = props.maxCharWidth,
      fixedCharWidth = props.fixedCharWidth,
      defaultCharWidth = props.defaultCharWidth,
      withEmptyLabel = props.withEmptyLabel,
      visible = props.visible;

  if (visible !== undefined && !visible) {
    return null;
  } // TODO check children is a Item or array of Item or br


  var extraCls = "";

  if (fixed) {
    extraCls += " " + classNamePrefix$2 + "-item-fixed";
  }

  if (full) {
    extraCls += " " + classNamePrefix$2 + "-item-full";
  }

  if (className) {
    extraCls += " " + className;
  }

  var extraStyle = {};

  if (fixedCharWidth) {
    extraStyle.minWidth = toWidth(fixedCharWidth);
    extraStyle.maxWidth = toWidth(fixedCharWidth);
  } else {
    if (minCharWidth) {
      extraStyle.minWidth = toWidth(minCharWidth);
    }

    if (maxCharWidth) {
      extraStyle.maxWidth = toWidth(maxCharWidth);
    }
  }

  if (defaultCharWidth) {
    extraStyle.width = toWidth(defaultCharWidth);
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$2 + "-item" + extraCls,
    style: extraStyle
  }, withEmptyLabel && /*#__PURE__*/React__default["default"].createElement("label", {
    className: 'arm-gui-cool-container-label ' + classNamePrefix$2 + '-empty-label'
  }, "\xA0"), children);
}

function Br$1(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$2 + "-item-br"
  });
}

Container.propTypes = {
  children: p__namespace.oneOfType([p__namespace.instanceOf(Group$1), p__namespace.node])
};
Group$1.propTypes = {
  legend: p__namespace.node,
  full: p__namespace.bool,
  asCommand: p__namespace.bool,
  noWrap: p__namespace.bool,
  compact: p__namespace.bool,
  children: p__namespace.oneOfType([p__namespace.element, p__namespace.node, p__namespace.instanceOf(Item$1), p__namespace.instanceOf(SubGroup), p__namespace.instanceOf(ItemGroup), p__namespace.instanceOf(Br$1)])
};
SubGroup.propTypes = {
  full: p__namespace.bool,
  noWrap: p__namespace.bool,
  compact: p__namespace.bool,
  children: p__namespace.oneOfType([p__namespace.element, p__namespace.node, p__namespace.instanceOf(SubGroup), p__namespace.instanceOf(Item$1), p__namespace.instanceOf(ItemGroup), p__namespace.instanceOf(Br$1)])
};
ItemGroup.propTypes = {
  legend: p__namespace.node,
  full: p__namespace.bool,
  children: p__namespace.oneOfType([p__namespace.element, p__namespace.node, p__namespace.instanceOf(Item$1) // p.instanceOf(Br),
  ])
};
Item$1.propTypes = {
  fixed: p__namespace.bool,
  full: p__namespace.bool,
  //
  minCharWidth: p__namespace.number,
  maxCharWidth: p__namespace.number,
  fixedCharWidth: p__namespace.number,
  defaultCharWidth: p__namespace.number,
  withEmptyLabel: p__namespace.bool,
  //
  children: p__namespace.node
};
Br$1.propTypes = {};
var Form = {
  Container: Container,
  Group: Group$1,
  SubGroup: SubGroup,
  ItemGroup: ItemGroup,
  Item: Item$1,
  Br: Br$1
};

/**
 * @typedef {object} BoardProps Board properties
 * @prop {string} [className] additional css class name
 * ```jsx
 * <Dash.Board className='my-dash'>
 *    ...
 * </Dash.Board>
 * ```
 * @prop {Node} [children] React.children
 */

/**
 * Component that contains dash item and eventually dash Group.
 * 
 * ```jsx
 * <Dash.Board className='my-dash'>
 *    <Dash.Group>
 *       <Dash.Item max={4}> 
 *          ...
 *       </Dash.Item> 
 *       <Dash.Item max={4}> 
 *          ...
 *       </Dash.Item> 
 *    </Dash.Group>
 *    <Dash.Item max={12}> 
 *       ...
 *    </Dash.Item> 
 * </Dash.Board>
 * ```
 * @callback _Board
 * @param {BoardProps} props
 * @returns {JSX.Element}
 */

/** @typedef {[red: number, green: number, blue: number]} RGBColor rgb array color */

/**
 * @typedef {object} GroupProps Dash.Group properties
 * @prop {string} [className] additional css class name
 * @prop {string} [legend] eventually legend element
 * @prop {boolean} [full] Group take full width 
 * @prop {boolean} [noWrap] Group has no wrap dash item inside (and horizontal gap will be half than default)
 * @prop {boolean|[left: RGBColor, right: RGBColor]} [highlighted] all the items have a linear background
 * @prop {Node} [children] React.children
 */

/**
 * Component that contains opctional group of dash Item.
 * 
 * @callback _Group
 * @param {GroupProps} props
 * @returns {JSX.Element}
 */

/**
 * @typedef {object} ItemProps Dash.Item properties
 * @prop {string} [className] additional css class name
 * @prop {boolean} [fixed] Item will be as large as inner (children) width (do not try to fill remain space).
 * @prop {boolean} [full] Item take full (100%) width 
 * @prop {number} [minWidth] min unit width
 * @prop {number} [maxWidth] max unit width
 * @prop {number} [fixedWidth] fixed unit width 
 * @prop {number} [defaultWidth] default initial (preferred) width in unit
 * @prop {boolean} [withoutCard] doesn't adds agui.aCard around content (children)
 * @prop {Node} [children] React.children
 */

/**
 * Component that contains single dash Item
 * 
 * @callback _Item
 * @param {ItemProps} props
 * @returns {JSX.Element}
 */
exports.typedef = {};

var classNamePrefix$1 = 'arm-core-layouts-dash';
var charUnit = "rem";
var defaultRemSizeUnit = 10;
var flexGapSupported = null;

function isFlexGapSupported() {
  if (flexGapSupported !== null) {
    return flexGapSupported;
  } // create flex Board with row-gap set


  var flex = document.createElement("div");
  flex.style.display = "flex";
  flex.style.flexDirection = "column";
  flex.style.rowGap = "1px"; // create two, elements inside it

  flex.appendChild(document.createElement("div"));
  flex.appendChild(document.createElement("div")); // append to the DOM (needed to obtain scrollHeight)

  document.body.appendChild(flex);
  var isSupported = flex.scrollHeight === 1; // flex Board should be 1px high from the row-gap

  flex.parentNode.removeChild(flex);
  flexGapSupported = isSupported;
  return isSupported;
}

function pickFromColors(color2, color1, weight) {
  var w1 = weight;
  var w2 = 1 - w1;
  var rgb = [Math.round(color1[0] * w1 + color2[0] * w2), Math.round(color1[1] * w1 + color2[1] * w2), Math.round(color1[2] * w1 + color2[2] * w2)];
  return rgb;
}

var DashboardContext = /*#__PURE__*/React__default["default"].createContext({
  remSizeUnit: defaultRemSizeUnit,
  inEdit: false,
  setRemSizeUnit: function setRemSizeUnit() {
    return null;
  },
  startEdit: function startEdit() {
    return null;
  },
  endEdit: function endEdit() {
    return null;
  },
  toggleEdit: function toggleEdit() {
    return null;
  }
});

var DashboardState = function DashboardState(_ref) {
  var children = _ref.children;

  var _useState = React.useState(defaultRemSizeUnit),
      remSizeUnit = _useState[0],
      setRemSizeUnit = _useState[1];

  var _useState2 = React.useState(false),
      inEdit = _useState2[0],
      setInEdit = _useState2[1];

  var startEdit = function startEdit() {
    setInEdit(true);
  };

  var endEdit = function endEdit() {
    setInEdit(false);
  };

  var toggleEdit = function toggleEdit() {
    setInEdit(!inEdit);
  };

  var setSizeUnit = function setSizeUnit(val) {
    setRemSizeUnit(val);
  };

  var providerValue = {
    remSizeUnit: remSizeUnit,
    inEdit: inEdit,
    startEdit: startEdit,
    endEdit: endEdit,
    toggleEdit: toggleEdit,
    setRemSizeUnit: setSizeUnit
  };
  console.log("dashboard provider", providerValue);
  return /*#__PURE__*/React__default["default"].createElement(DashboardContext.Provider, {
    value: providerValue
  }, children);
};

var getDashboardState = function getDashboardState() {
  var context = React.useContext(DashboardContext);

  if (!context) {
    throw Error('Use useDashboard inside DashboardProvider');
  }

  return context;
};
/** @type {_Board} */


function Board(props) {
  return /*#__PURE__*/React__default["default"].createElement(DashboardState, null, /*#__PURE__*/React__default["default"].createElement(BoardContainer, props));
}

function BoardContainer(props) {
  var children = props.children,
      className = props.className,
      visible = props.visible,
      minWidth = props.minWidth,
      remSizeUnit = props.remSizeUnit,
      editable = props.editable;

  if (visible !== undefined && !visible) {
    return null;
  }

  var dashContext = getDashboardState();

  if (remSizeUnit) {
    setTimeout(function () {
      dashContext.setRemSizeUnit(remSizeUnit);
      console.log("change dashContext.remSizeUnit:", dashContext.remSizeUnit);
    }, 10);
  }

  var extraCls = "";

  if (className) {
    extraCls += " " + className;
  }

  var isGapSupported = isFlexGapSupported();

  if (!isGapSupported) {
    extraCls += " " + (classNamePrefix$1 + "-gap-not-supported");
  }

  var extraStyle = {};

  if (minWidth) {
    extraStyle.minWidth = toSize(minWidth, remSizeUnit);
  }

  var editKnot = null;

  if (editable) {
    var editBtn = function editBtn() {
      console.log("click edit btn", dashContext.inEdit);
      dashContext.toggleEdit();
    };

    editKnot = /*#__PURE__*/React__default["default"].createElement("div", {
      className: classNamePrefix$1 + "-board-edit-knot",
      onClick: editBtn
    }, dashContext.inEdit && /*#__PURE__*/React__default["default"].createElement("i", {
      className: "fa fa-save text-success",
      title: "Fine modifica"
    }), !dashContext.inEdit && /*#__PURE__*/React__default["default"].createElement("i", {
      className: "fa fa-pencil",
      title: "Modifica"
    }));

    if (dashContext.inEdit) {
      extraCls += " board-editing";
    }
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$1 + "-board" + extraCls,
    style: extraStyle
  }, editKnot, children);
}

var DashGroupContext = /*#__PURE__*/React__default["default"].createContext({
  highlighted: false,
  height: null,
  width: null
});

var useGroup = function useGroup() {
  var context = React.useContext(DashGroupContext);

  if (!context) {
    throw Error('Use useDashboard inside DashboardProvider');
  }

  return context;
};
/** @type {_Group} */


function Group(props) {
  var _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      children = props.children,
      full = props.full,
      className = props.className,
      asCommand = props.asCommand,
      highlighted = props.highlighted;
  if (!visible) return null;
  var extraCls = "";

  if (full) {
    extraCls += " " + classNamePrefix$1 + "-group-full";
  }

  if (className) {
    extraCls += " " + className;
  }

  if (asCommand) {
    extraCls += " " + classNamePrefix$1 + "-group-commands";
  }

  if (highlighted) {
    extraCls += " " + classNamePrefix$1 + "-group-highlighted";
  }

  var _useState3 = React.useState({
    height: null,
    width: null
  }),
      _useState3$ = _useState3[0],
      height = _useState3$.height,
      width = _useState3$.width,
      setSize = _useState3[1];

  var ref = highlighted ? React.useRef() : null;
  React.useEffect(function () {
    if (ref != null && ref.current && highlighted) {
      var resizeObserver = new ResizeObserver(function () {
        //Debouncer.debounce(idComp, 50, ()  => setWidth(elementBarRef.current.offsetWidth))
        setSize({
          height: ref.current.offsetHeight,
          width: ref.current.offsetWidth
        });
      });
      resizeObserver.observe(ref.current);
    }
  }, [ref]);
  return /*#__PURE__*/React__default["default"].createElement(DashGroupContext.Provider, {
    value: {
      highlighted: highlighted,
      width: width,
      height: height
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    ref: ref,
    className: classNamePrefix$1 + "-group " + extraCls
  }, children));
}

function Header(props) {
  var children = props.children,
      visible = props.visible; //

  if (visible !== undefined && !visible) return null;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
}
/** @type {_Item} */


function Item(props) {
  var children = props.children,
      fixed = props.fixed,
      full = props.full,
      className = props.className,
      minWidth = props.minWidth,
      maxWidth = props.maxWidth,
      fixedWidth = props.fixedWidth,
      defaultWidth = props.defaultWidth,
      visible = props.visible,
      centered = props.centered,
      metaName = props.metaName,
      metaDescription = props.metaDescription;
  var dashContext = getDashboardState();
  var remSizeUnit = dashContext.remSizeUnit,
      inEdit = dashContext.inEdit;

  if (visible !== undefined && !visible) {
    return null;
  }

  var extraCls = "";

  if (fixed) {
    extraCls += " " + classNamePrefix$1 + "-item-fixed";
  }

  if (full) {
    extraCls += " " + classNamePrefix$1 + "-item-full";
  }

  if (centered) {
    extraCls += " " + classNamePrefix$1 + "-item-centered";
  }

  if (className) {
    extraCls += " " + className;
  }

  var _useState4 = React.useState({}),
      extraStyle = _useState4[0],
      setExtraStyle = _useState4[1];

  var body = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
  var title = null;
  var metaElem = metaName ? "" + metaName + (metaDescription ? " - " + metaDescription : "") : "Elemento";

  var _useGroup = useGroup(),
      highlighted = _useGroup.highlighted,
      height = _useGroup.height,
      width = _useGroup.width;

  var ref = highlighted ? React.useRef() : null;
  React.useEffect(function () {
    var style = {};

    if (fixedWidth) {
      style.minWidth = toSize(fixedWidth, remSizeUnit);
      style.maxWidth = toSize(fixedWidth, remSizeUnit);
    } else {
      if (minWidth) {
        style.minWidth = toSize(minWidth, remSizeUnit);
      }

      if (maxWidth) {
        style.maxWidth = toSize(maxWidth, remSizeUnit);
      }
    }

    if (defaultWidth) {
      style.width = toSize(defaultWidth, remSizeUnit);
    }

    if (ref != null && ref.current && highlighted) {
      var vw = window.innerWidth; //TODO: agganciare il size di pagecontainer

      var _ref$current$getBound = ref.current.getBoundingClientRect(),
          left = _ref$current$getBound.left,
          right = _ref$current$getBound.right;

      var color1 = [57, 116, 198];
      var color2 = [76, 203, 171];

      if (typeof highlighted === 'object') {
        color1 = highlighted[0];
        color2 = highlighted[1];
      }

      var leftColor = pickFromColors(color1, color2, left / vw);
      var rightColor = pickFromColors(color1, color2, right / vw);
      style.backgroundImage = "linear-gradient(90deg, rgb(" + leftColor.join() + ") 0%, rgb(" + rightColor.join() + ") 100%)";
    }

    setExtraStyle(style);
  }, [ref, height, width]); //TODO: agganciare il size di pagecontainer

  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: ref,
    className: classNamePrefix$1 + "-item" + extraCls,
    title: title,
    style: extraStyle
  }, inEdit && /*#__PURE__*/React__default["default"].createElement("div", {
    title: metaElem + " - Dashboard in modifica",
    className: classNamePrefix$1 + "-item-edit-canvas"
  }), body);
}

function Br(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNamePrefix$1 + "-item-br"
  });
}

Board.propTypes = {
  className: p__namespace.string,
  //
  visible: p__namespace.bool,
  //
  children: p__namespace.oneOfType([p__namespace.instanceOf(Group), p__namespace.instanceOf(Item), p__namespace.instanceOf(Br), p__namespace.node])
};
Group.propTypes = {
  className: p__namespace.string,
  metaName: p__namespace.string,
  metaDescription: p__namespace.string,
  legend: p__namespace.node,
  full: p__namespace.bool,
  asCommand: p__namespace.bool,
  noWrap: p__namespace.bool,
  visible: p__namespace.bool,
  highlighted: p__namespace.oneOfType([p__namespace.bool, p__namespace.arrayOf(p__namespace.arrayOf(p__namespace.number))]),
  children: p__namespace.oneOfType([p__namespace.instanceOf(Item), p__namespace.instanceOf(Br), p__namespace.element, p__namespace.node])
};
Item.Header = Header;
Item.propTypes = {
  className: p__namespace.string,
  metaName: p__namespace.string,
  metaDescription: p__namespace.string,
  fixed: p__namespace.bool,
  full: p__namespace.bool,
  //
  centered: p__namespace.bool,
  //
  minWidth: p__namespace.number,
  maxWidth: p__namespace.number,
  fixedWidth: p__namespace.number,
  defaultWidth: p__namespace.number,
  withoutCard: p__namespace.bool,
  //
  visible: p__namespace.bool,
  //
  children: p__namespace.node
};
Br.propTypes = {};
var Dash = {
  Board: Board,
  Group: Group,
  Item: Item,
  Br: Br,
  remSizeUnit: defaultRemSizeUnit
};

function toSize(val, remSizeUnit) {
  var v = "" + val * (remSizeUnit || Dash.remSizeUnit || defaultRemSizeUnit) + "" + charUnit;
  return "min(100%, " + v + ")";
}

/**
 * @typedef {Object} _NotificationConfig
 * @prop {number} timeOut default duration of notify (5000ms)
 * @prop {number} transition duration of transition (in concatenation of css selector `transition` rule)
 */

/**
 * @typedef {Object} NotificationOptions
 * @prop {string} header notify header
 * @prop {number} timeOut duration of notify. If is 0, the notify needs to be closed manually
 * @prop {() => any} onClick function that starts when notify is about to close. When `onClick` is present, `timeOut` isn't considered
 */

/**
 * @typedef {Object} NotificationManagerInstance
 * @prop {(message: string, options: NotificationOptions) => void} info Dispatch an info message to NotificationContainer
 * @prop {(message: string, options: NotificationOptions) => void} success Dispatch a success message to NotificationContainer
 * @prop {(message: string, options: NotificationOptions) => void} warning Dispatch a warning message to NotificationContainer
 * @prop {(message: string, options: NotificationOptions) => void} error Dispatch an error message to NotificationContainer
 */
exports.typedef = {};

var createUUID = function createUUID() {
  var pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return pattern.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

var NotificationConstants = Object.freeze({
  CHANGE: 'change',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
});
/** @type {_NotificationConfig} */

var NotificationConfig = {
  timeOut: 5000,
  transition: 300
};

var NotificationManager = /*#__PURE__*/function (_EventEmitter) {
  _inheritsLoose(NotificationManager, _EventEmitter);

  function NotificationManager() {
    var _this;

    _this = _EventEmitter.call(this) || this;
    _this.listNotify = [];
    return _this;
  }

  var _proto = NotificationManager.prototype;

  _proto.create = function create(notify) {
    if (notify.priority) this.listNotify.unshift(notify);else this.listNotify.push(notify);
    this.emitChange();
  };

  _proto._buildOpts = function _buildOpts(message, type, options) {
    if (options === void 0) {
      options = {};
    }

    return _extends({
      timeOut: NotificationConfig.timeOut
    }, options, {
      message: message,
      type: type,
      id: createUUID()
    });
  };

  _proto.info = function info(message, options) {
    var opts = this._buildOpts(message, NotificationConstants.INFO, options);

    this.create(opts);
  };

  _proto.success = function success(message, options) {
    var opts = this._buildOpts(message, NotificationConstants.SUCCESS, options);

    this.create(opts);
  };

  _proto.warning = function warning(message, options) {
    var opts = this._buildOpts(message, NotificationConstants.WARNING, options);

    this.create(opts);
  };

  _proto.error = function error(message, options) {
    var opts = this._buildOpts(message, NotificationConstants.ERROR, options);

    this.create(opts);
  };

  _proto.remove = function remove(notification) {
    this.listNotify = this.listNotify.filter(function (n) {
      return notification.id !== n.id;
    });
    this.emitChange();
  };

  _proto.emitChange = function emitChange() {
    this.emit(NotificationConstants.CHANGE, this.listNotify);
  };

  _proto.addChangeListener = function addChangeListener(callback) {
    this.addListener(NotificationConstants.CHANGE, callback);
  };

  _proto.removeChangeListener = function removeChangeListener(callback) {
    this.removeListener(NotificationConstants.CHANGE, callback);
  };

  return NotificationManager;
}(events.EventEmitter);
/** @type {NotificationManagerInstance} */


var NotificationManager$1 = new NotificationManager();

var notificationClassName = 'arm-core-layouts-notification';

var Notification = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Notification, _React$Component);

  function Notification(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.requestHide = _this.requestHide.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Notification.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        timeOut = _this$props.timeOut,
        onClick = _this$props.onClick;
    if (timeOut !== 0 && !onClick) this.timer = setTimeout(this.requestHide, timeOut);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.timer) clearTimeout(this.timer);
  };

  _proto.handleClick = function handleClick() {
    var onClick = this.props.onClick;
    if (onClick) onClick();
    this.requestHide();
  };

  _proto.requestHide = function requestHide() {
    var onRequestHide = this.props.onRequestHide;
    if (onRequestHide) onRequestHide();
  };

  _proto.getSymbol = function getSymbol() {
    switch (this.props.type) {
      case NotificationConstants.SUCCESS:
        return 'fas fa-check-circle';

      case NotificationConstants.WARNING:
        return 'fas fa-exclamation-triangle';

      case NotificationConstants.ERROR:
        return 'fas fa-times-circle';

      default:
        return 'fas fa-info-circle';
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$type = _this$props2.type,
        type = _this$props2$type === void 0 ? 'info' : _this$props2$type,
        header = _this$props2.header,
        _this$props2$message = _this$props2.message,
        message = _this$props2$message === void 0 ? '' : _this$props2$message;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: notificationClassName + " " + notificationClassName + "-" + type,
      role: "alert"
    }, /*#__PURE__*/React__default["default"].createElement("i", {
      className: notificationClassName + "-icon " + this.getSymbol()
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: notificationClassName + "-body"
    }, header && /*#__PURE__*/React__default["default"].createElement("div", {
      className: notificationClassName + "-header"
    }, header), /*#__PURE__*/React__default["default"].createElement("div", {
      className: notificationClassName + "-message"
    }, message)), /*#__PURE__*/React__default["default"].createElement("i", {
      className: notificationClassName + "-close fas fa-times",
      onClick: this.handleClick
    }));
  };

  return Notification;
}(React__default["default"].Component);

var classNamePrefix = 'arm-core-layouts-notification-group';

var NotificationGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(NotificationGroup, _React$Component);

  function NotificationGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NotificationGroup.prototype;

  _proto.handleRequestHide = function handleRequestHide(notification) {
    var _this = this;

    return function () {
      var onRequestHide = _this.props.onRequestHide;
      if (onRequestHide) onRequestHide(notification);
    };
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        _this$props$notificat = _this$props.notifications,
        notifications = _this$props$notificat === void 0 ? [] : _this$props$notificat,
        _this$props$timeout = _this$props.timeout,
        timeout = _this$props$timeout === void 0 ? NotificationConfig.transition : _this$props$timeout;
    return /*#__PURE__*/React__default["default"].createElement(reactTransitionGroup.TransitionGroup, {
      className: (classNamePrefix + " " + (notifications.length === 0 ? classNamePrefix + "-empty" : '')).trimEnd()
    }, notifications.map(function (notification) {
      var key = notification.id || new Date().getTime();
      return /*#__PURE__*/React__default["default"].createElement(reactTransitionGroup.CSSTransition, {
        key: key,
        classNames: notificationClassName,
        timeout: timeout
      }, /*#__PURE__*/React__default["default"].createElement(Notification, {
        type: notification.type,
        header: notification.header,
        message: notification.message,
        timeOut: notification.timeOut,
        onClick: notification.onClick,
        onRequestHide: _this2.handleRequestHide(notification)
      }));
    }));
  };

  return NotificationGroup;
}(React__default["default"].Component);

var NotificationContainer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(NotificationContainer, _React$Component);

  function NotificationContainer(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      notifications: []
    };
    _this.handleStoreChange = _this.handleStoreChange.bind(_assertThisInitialized(_this));
    _this.handleRequestHide = _this.handleRequestHide.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = NotificationContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    NotificationManager$1.addChangeListener(this.handleStoreChange);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    NotificationManager$1.removeChangeListener(this.handleStoreChange);
  };

  _proto.handleStoreChange = function handleStoreChange(notifications) {
    this.setState({
      notifications: notifications
    });
  };

  _proto.handleRequestHide = function handleRequestHide(notification) {
    NotificationManager$1.remove(notification);
  };

  _proto.render = function render() {
    var notifications = this.state.notifications;
    return /*#__PURE__*/React__default["default"].createElement(NotificationGroup, {
      notifications: notifications,
      onRequestHide: this.handleRequestHide
    });
  };

  return NotificationContainer;
}(React__default["default"].Component);

var Layouts = {
  version: pckg.version,
  VBox: VBox,
  HBox: HBox,
  ApplicationContainer: ApplicationContainer,
  CollapseContent: CollapseContent,
  MenuLeft: MenuLeft,
  TopBar: TopBar,
  MasterPageContainer: MasterPageContainer,
  PageHeaderContainer: PageHeaderContainer,
  PageContainer: PageContainer,
  PageHeader: PageHeader,
  PageFilter: PageFilter,
  PageFilterGroup: PageFilterGroup,
  PageFilterPanel: PageFilterPanel,
  PageBody: PageBody,
  PageFooter: PageFooter,
  PageFooterGroup: PageFooterGroup,
  SidePopup: SidePopup,
  Wizard: Wizard,
  ElementBar: ElementBar,
  AutoSize: AutoSize,
  Spinner: Spinner,
  Form: Form,
  Dash: Dash,
  NotificationConfig: NotificationConfig,
  NotificationManager: NotificationManager$1,
  NotificationContainer: NotificationContainer
};

exports.ApplicationContainer = ApplicationContainer;
exports.AutoSize = AutoSize;
exports.CollapseContent = CollapseContent;
exports.Dash = Dash;
exports.ElementBar = ElementBar;
exports.Form = Form;
exports.HBox = HBox;
exports.MasterPageContainer = MasterPageContainer;
exports.MenuLeft = MenuLeft;
exports.NotificationConfig = NotificationConfig;
exports.NotificationContainer = NotificationContainer;
exports.NotificationManager = NotificationManager$1;
exports.PageBody = PageBody;
exports.PageContainer = PageContainer;
exports.PageFilter = PageFilter;
exports.PageFilterGroup = PageFilterGroup;
exports.PageFilterPanel = PageFilterPanel;
exports.PageFooter = PageFooter;
exports.PageFooterGroup = PageFooterGroup;
exports.PageHeader = PageHeader;
exports.PageHeaderContainer = PageHeaderContainer;
exports.SidePopup = SidePopup;
exports.Spinner = Spinner;
exports.TopBar = TopBar;
exports.VBox = VBox;
exports.Wizard = Wizard;
exports["default"] = Layouts;
//# sourceMappingURL=index.js.map
